import React from 'react'
import { NavLink } from 'react-router-dom'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Page/Contact'
import Footer from '../../component/Page/Footer'
import Testimonial from '../../component/Page/Testimonial'


const Service = () => {
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section>
                <div className="container">
                    <div className="text-center mb__5">
                        <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                            <img src="./../images/Vector 2.png" alt="" />
                            <span className="mx-3">Services</span>
                            <img src="./../images/Vector 1.png" alt="" />
                        </div>
                        <h2 className="medium font__size--56 text__50-1024 text__50-sm text__50-xs play">We are committed to providing <br /> the best service</h2>
                    </div>


                    <div className="row justify-content-center mb__5">
                        <div className="col-md-4 text-center text-md-left mb-4 mb-md-0">
                            <img src="./../images/sv (3).png" className='' alt="" />
                        </div>
                        <div className="col-md-6 ">
                            <div className="d-flex align-items-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">Design</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="semi-bold font__size--24 text__24-1024 play mb-4">Our can help couples determine their wedding theme or concept and create suitable decoration and invitation designs.</h2>

                            <ul className='medium font__size--20 text__20-1024 play mb-5 pl-4'>
                                <li>Website Design</li>
                                <li>Wedding Concept Design</li>
                                <li>Invitation Design</li>
                                <li>Style Consultation</li>
                            </ul>

                            <NavLink
                                to="/service/design" className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow text-capitalize rounded__50 h__white no__opacity pointer" >See Details</NavLink>
                        </div>
                    </div>


                    <div className="row justify-content-center mb__5">
                        <div className="col-md-6 order-md-1 order-12 ">
                            <div className="d-flex align-items-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">Planning</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="semi-bold font__size--24 text__24-1024 play mb-4">Our can assist couples in selecting the wedding location, vendors, and planning a schedule that runs smoothly on their wedding day.</h2>

                            <ul className='medium font__size--20 text__20-1024 play mb-5 pl-4'>
                                <li>Free Consultation</li>
                                <li>Vendor Arrangements</li>
                                <li>Event Coordination</li>
                                <li>Beauty Services</li>
                            </ul>

                            <NavLink
                                to="/service/planning" className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow text-capitalize rounded__50 h__white no__opacity pointer" >See Details</NavLink>
                        </div>
                        <div className="col-md-4 text-center text-md-left mb-4 mb-md-0 order-1 order-md-12">
                            <img src="./../images/sv (1).png" className='' alt="" />
                        </div>
                    </div>



                    <div className="row justify-content-center">
                        <div className="col-md-4 text-center text-md-left mb-4 mb-md-0">
                            <img src="./../images/sv (2).png" className='' alt="" />
                        </div>
                        <div className="col-md-6 ">
                            <div className="d-flex align-items-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">Photography</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="semi-bold font__size--24 text__24-1024 play mb-4">Our can help couples determine the desired photo style and provide advice on clothing and accessories suitable for their photo session. You can also assist in creating a wedding photo album.</h2>

                            <ul className='medium font__size--20 text__20-1024 play mb-5 pl-4'>
                                <li>Pre-Wedding Photoshoot</li>
                                <li>Wedding Day Photography</li>
                                <li>Video Shooting</li>
                                <li>Photo Editing Service</li>
                                <li>Photo Album</li>
                            </ul>

                            <NavLink
                                to="/service/photography"  className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow text-capitalize rounded__50 h__white no__opacity pointer" >See Details</NavLink>
                        </div>
                    </div>

                </div>
            </section>

            <Testimonial />

            <Contact />

            <Footer />
        </div >
    )
}

export default Service